const FormHelpers = {
  validateFields(fieldRefs) {
    let formIsValid = true;
    fieldRefs.forEach((fieldRef) => {
      if (fieldRef && fieldRef.validate) {
        const fieldIsValid = fieldRef.validate();
        formIsValid = formIsValid && fieldIsValid;
      }
    });
    return formIsValid;
  },

  validateField(required, value, validateFunc) {
    if (!required && !validateFunc) return true;

    let trimmedValue = value;
    if (typeof value === 'string') {
      trimmedValue = value && value.trim();
    }

    if (required && !trimmedValue) {
      return { requiredError: true, validateError: false };
    }
    if (validateFunc && trimmedValue && !validateFunc(trimmedValue)) {
      return { validateError: true, requiredError: false };
    }
    return { validateError: false, requiredError: false };
  },
};

module.exports = FormHelpers;
